/*
 * Bulk birthday import. Sits next to the "Clear all" affordance in
 * the Calendar settings panel. File picker → parse → preview rows
 * → "Add all" pushes them through the existing single-add API.
 */

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
}

.label {
  font-size: 12px;
  color: rgba(28, 38, 32, 0.7);
}

.fileButton {
  font-family: var(--token-font-ui);
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid rgba(28, 38, 32, 0.2);
  background: rgba(255, 255, 255, 0.85);
  color: var(--token-text-primary);
  cursor: pointer;
  transition: background 120ms ease;
}

.fileButton:hover {
  background: #fff;
}

.fileInput {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.hint {
  margin: 0;
  font-size: 11px;
  color: rgba(28, 38, 32, 0.55);
  line-height: 1.4;
}

/* ---------- Preview area ---------- */

.preview {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  background: color-mix(in srgb, var(--token-accent) 8%, transparent);
  border: 1px solid color-mix(in srgb, var(--token-accent) 30%, transparent);
}

.previewHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.previewSummary {
  font-family: var(--token-font-ui);
  font-size: 13px;
  font-weight: 600;
  color: var(--token-text-primary);
}

.previewActions {
  display: flex;
  gap: 6px;
}

.addAllButton {
  font-family: var(--token-font-ui);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.3px;
  padding: 6px 16px;
  border-radius: 999px;
  border: 1.5px solid var(--token-accent);
  background: var(--token-accent);
  color: #fff;
  cursor: pointer;
  transition: background 120ms ease;
}

.addAllButton:hover:not(:disabled) {
  background: color-mix(in srgb, var(--token-accent) 85%, #000);
}

.addAllButton:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cancelButton {
  font-family: var(--token-font-ui);
  font-size: 13px;
  font-weight: 600;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid rgba(28, 38, 32, 0.2);
  background: transparent;
  color: rgba(28, 38, 32, 0.7);
  cursor: pointer;
}

.cancelButton:hover {
  background: rgba(28, 38, 32, 0.06);
}

.errors {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 6px;
  border-top: 1px dashed rgba(176, 58, 46, 0.4);
}

.errorsHead {
  font-family: var(--token-font-ui);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: rgba(176, 58, 46, 0.85);
}

.errorItem {
  font-size: 12px;
  color: rgba(176, 58, 46, 0.9);
  line-height: 1.4;
}

.errorRow {
  display: inline-block;
  min-width: 36px;
  text-align: right;
  margin-right: 6px;
  font-variant-numeric: tabular-nums;
  color: rgba(176, 58, 46, 0.7);
}

.status {
  font-size: 12px;
  color: rgba(28, 38, 32, 0.65);
  font-family: var(--token-font-ui);
  letter-spacing: 0.2px;
}

.statusError {
  color: rgba(176, 58, 46, 0.95);
}

.statusSuccess {
  color: rgba(48, 112, 64, 0.95);
  font-weight: 600;
  margin-top: 6px;
}
